export const NITRATE_BORATE_LOGIC = {
  description: "Nitrates & Borates Identification Rules",
  
  coreRules: `
=== 硝酸盐与硼酸盐鉴定法则 (Nitrates & Borates Diagnostic Protocol) ===

[6.1 硼酸盐的经典白晶系 (The Core White Borates)]
*   **斜方硼砂 / 贫水硼砂 (Kernite)**: 重要的硼矿石。长得像白色的干冰或石膏。必须寻找其**沿着解理面断裂成非常长的、无色或白色的可劈开的长条状/劈刀状晶体 (Cleavage parallel to long fibers)**。有时表面会因为失水而产生发白的粉末状外壳。
*   **钠硼解石 (Ulexite)**: 极度著名的**“电视石” (TV Stone)**。
    *   【终极光学锚点】：当它被切割成平整的块状时（如图中呈现的那样），它具有平行排列的极细纤维。光线沿着这些纤维如同光纤一样传导。因此，如果在标本描述或图片中看到一块像肥皂一样的白砖，具有规则的直边界纹理，直接锁定钠硼解石。
*   **白硼钙石 (Colemanite)**:
    *   【形态锚点】：通常呈现无色到白色的**短柱状、块状甚至像冰糖一样的晶体团块 (Blocky to crystalline masses)**。它往往具有玻璃光泽并且比另外两者更显“结实”或形成有明显切面的晶簇，而不是电视石的光纤状或贫水硼砂的长劈面。
*   **三斜硼钙石 / 软硼钙石 (Inyoite)**: 罕见的富水硼钙石。
    *   【破绽】：虽然也是无色到白色的晶体，但它极易风化，表面常会变成浑浊的白色粉末状。如果看到像一堆脆弱的、表面起粉的白色到微粉色/微黄色的斜块状晶体群，要考虑这个罕见变种。

[6.2 重金属的奇异硼酸盐 (Heavy & Exotic Borates)]
*   **硼镁铁矿 (Ludwigite)**: 彻底打破了硼酸盐是白色透明的刻板印象。
    *   【极黑的放射纹】：它通常呈现出**极度暗黑、黑绿色甚至深褐色的致密块状或极细的放射状/纤维状集合体 (Black radiating fibrous masses)**。在博物馆标本中，如果一块石头看起来像是一团黑色的、布满平行或者放射状纤维纹理的煤块/结晶渣，它是硼铁矿床中的硼镁铁矿。
*   **氯镁铅矿 / 硬硼钙石 混淆提醒 (Chloroxiphite / Boracite / etc.)**: 
    *   *注意*：你提供的图像中有写“氯镁铅矿 / 硬硼钙石”。
    *   **硬硼钙石 (Priceite/Pandermite)**: 如果它是纯白色的、看起来像毫无结晶特征的**白垩、粉笔灰或白色粘土块 (Chalky white nodules/masses)**，这是典型的硬硼钙石/硬硼钙石变种。
    *   如果标本体现出罕见的铅绿/黄特征，那是极度罕见的次生铅矿物。若是图中纯白且呈现三角堆积状结晶，更须结合它所处的光泽度以及产地。
*   **氟硼镁石 (Szaibelyite) vs 硼镁矿 (Ascharite/Szaibelyite)**: 同种矿物的不同译名。
    *   【土状与纤维锚点】：通常呈**白色、灰白色或微带黄色的土状块体，或是极细小的毛发状、针状结晶组成的结节 (Chalky nodules or fine fibrous aggregates)**。如果你看到一块石头长得像夹杂在黑色/暗色围岩中的一块脏旧的干木头、或者是干燥的皮壳，就是它。

[6.3 极端矿床与共生指示 (Extreme Deposits)]
*   **记住死亡谷 (Death Valley) 与盐湖**: 硼酸盐的诞生必须伴随着极度干旱的盐湖床（Playas）。所以几乎所有的硼酸盐（Kernite, Ulexite, Colemanite）身上都带着“极易溶于水”、“脆弱”、“灰白”的荒漠干涸滤镜。
*   **硼镁铁矿的接触变质带**: Ludwigite 绝对不在盐湖里，它长在高温接触交代矿床（矽卡岩）里，常与磁铁矿共生，这就是为什么它黑得发亮。
`,

  diagnosticTests: `
- 面对一块白色的硼酸盐：如果有“光纤”传导特征或呈现完美的纤维状方块，是钠硼解石 (电视石)；如果是一长条能劈开的“干冰”状长块，是贫水硼砂；如果是短粗的冰糖状晶体，是白硼钙石。
- 如果在硼酸盐标签下看到一块全黑的、长满放射状黑针/黑纤维的石头，它是硼镁铁矿。
- 看到像粉笔灰、白土一样的白色块体，考虑硬硼钙石或氟硼镁石等致密/土状硼酸盐。
`
};
